import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "demo-progress" }
const _hoisted_2 = { class: "percentage-value" }
const _hoisted_3 = { class: "percentage-label" }
const _hoisted_4 = { class: "dialog-footer" }

import { computed, ref, watch, PropType, onUnmounted } from 'vue'
import { ElDialog } from 'element-plus'
import { useI18n } from 'vue-i18n'
import { exportOrderReport, getExportOrderReportInfo } from '@/api/operation'
import { ElMessage, ElMessageBox } from 'element-plus'
import { CommonState } from '@/types/types'


import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'ReportingExport',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  info: {
    type: Object as PropType<Record<string, any>>,
  },
},
  emits: ["update:modelValue", "submitted"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:modelValue', value: boolean): void
  (e: 'submitted'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props

const { t } = useI18n()





const isSubmitting = ref(false)
const showDialog = computed({
  get: () => props.modelValue,
  set: (val: boolean) => {
    emit('update:modelValue', val)
    if (!val) {
      // 对话框关闭时清除定时器
      if (intervalId.value) {
        clearInterval(intervalId.value)
        intervalId.value = null
      }
    }
  },
})

const downloadUrl = ref<string>('')
const intervalId = ref<number | null>(null)
const maxRetryTime = 60000 // 1 分钟
const retryInterval = 1000 // 5 秒
const percentage = ref(0)

// 下载文件
const downloadFile = () => {
  if (downloadUrl.value) {
    isSubmitting.value = true // 开始加载

    // 创建一个隐藏的 <a> 标签
    const link = document.createElement('a')
    link.href = downloadUrl.value
    link.setAttribute('download', '') // 设置 download 属性（可选）
    document.body.appendChild(link)

    // 触发点击事件
    link.click()

    // 移除 <a> 标签
    document.body.removeChild(link)

    isSubmitting.value = false // 结束加载
  } else {
    console.error('Download URL is empty.')
  }
}

const loadInfo = async (retry: boolean) => {
  try {
    isSubmitting.value = true
    const res = await getExportOrderReportInfo({ reportId: props.info?.id, retry: retry })
    if (res.info.state == CommonState.CMS_FAIL || res.info.state == CommonState.CMS_CLOSE) {
      ElMessage.warning(t('Operation.genFail'))
      clearInterval(intervalId.value!)
      return
    }
    downloadUrl.value = res.info.filePath
    if (res.info.totalOrderNum <= 0) {
      percentage.value = 100
    } else {
      percentage.value = Math.floor((res.info.exportOrderNum / res.info.totalOrderNum) * 100)
    }
    if (percentage.value > 100) {
      percentage.value = 100
    }
    if (res.info.filePath) {
      clearInterval(intervalId.value!)
    }
  } catch (error) {
    console.log('getExportOrderReportInfo error:', error)
  } finally {
    isSubmitting.value = false
  }
}

const genExport = async (retry: boolean) => {
  try {
    isSubmitting.value = true

    if (retry) {
      percentage.value = 0
    }
    const res = await exportOrderReport({ reportId: props.info?.id, retry: retry })
    downloadUrl.value = res.url

    if (!res.url) {
      intervalId.value = setInterval(() => {
        loadInfo(true)
      }, retryInterval) as unknown as number

      setTimeout(() => {
        if (intervalId.value) {
          clearInterval(intervalId.value)
          intervalId.value = null
          console.log('Retry stopped after 1 minute.')
        }
      }, maxRetryTime)
    } else {
      percentage.value = 100
    }
  } catch (error) {
    console.log('getExportOrderReportInfo error:', error)
  } finally {
    isSubmitting.value = false
  }
}

watch(
  () => props.info,
  (newVal) => {
    if (newVal?.id) {
      genExport(false)
    }
  },
  { immediate: true },
)

// 监听 showDialog 的变化
watch(showDialog, (newVal) => {
  if (!newVal && intervalId.value) {
    // 对话框关闭时清除定时器
    clearInterval(intervalId.value)
    intervalId.value = null
  }
})

onUnmounted(() => {
  if (intervalId.value) {
    clearInterval(intervalId.value)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(_unref(ElDialog), {
    modelValue: _unref(showDialog),
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : null)),
    width: "40%",
    class: "upsert-dialog",
    title: _ctx.$t('Base.export'),
    "z-index": 2000
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_4, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (genExport(true))),
          disabled: !_ctx.$hasPermission('post'),
          loading: isSubmitting.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.retry')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: downloadFile,
          disabled: !_ctx.$hasPermission('post') || !downloadUrl.value,
          loading: isSubmitting.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.download')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_progress, {
          type: "dashboard",
          percentage: percentage.value
        }, {
          default: _withCtx(({ percentage }) => [
            _createElementVNode("span", _hoisted_2, _toDisplayString(percentage) + "%", 1),
            _createElementVNode("span", _hoisted_3, _toDisplayString(percentage >= 100 ? _unref(t)('Base.done') : _unref(t)('Base.gening')), 1)
          ]),
          _: 1
        }, 8, ["percentage"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})